import { render, staticRenderFns } from "./QuestionInputRadio.vue?vue&type=template&id=0a36936d&scoped=true&"
import script from "./QuestionInputRadio.vue?vue&type=script&lang=js&"
export * from "./QuestionInputRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a36936d",
  null
  
)

export default component.exports